import request from '@/utils/request';
import Resource from '@/api/resource';

class MaterialResource extends Resource {
  constructor() {
    super('/material');
  }

  // 素材上传
  updataMaterialApi(data) {
    return request({
      url: `${this.uri}/local/add`,
      method: 'post',
      data,
      headers: {
        'Content-Type':	'multipart/form-data; charset=UTF-8',
      },
    });
  }

  // 删除素材
  removeMaterialApi(data) {
    return request({
      url: `${this.uri}/local/${data.id}/delete`,
      method: 'delete',
      data,
    });
  }

  // 下载素材
  downloadMaterialApi(data) {
    return request({
      url: `${this.uri}/local/${data.id}/download`,
      method: 'get',
      responseType: 'blob',
      headers: {
        'accept':	'application/zip',
      },
    });
  }

  // 更新素材备注
  updateNoteApi(data, id) {
    return request({
      url: `${this.uri}/local/${id}/updateNote`,
      method: 'post',
      data,
    });
  }

  /**
   * 更新素材标签
   * @param params 接口参数
   * @param id 当前选中行的id
  */
  updateTagApi(data, id) {
    return request({
      url: `${this.uri}/local/${id}/updateTag`,
      method: 'post',
      data,
    });
  }

  /**
   * 更新素材名称
   * @param {Object} data 请求体参数
   * @param {number} id 素材ID
   * @returns
   */
  updateNameApi(data, id) {
    return request({
      url: `${this.uri}/local/${id}/updateName`,
      method: 'post',
      data,
    });
  }

  /**
   * 更新素材需求方
   * @param {Object} data 请求体参数
   * @param {number} id 素材ID
   * @returns
   */
  updateDemandSiderApi(data, id) {
    return request({
      url: `${this.uri}/local/${id}/updateDemandSider`,
      method: 'post',
      data,
    });
  }

  // 获取素材列表
  getMaterialListApi(params) {
    return request({
      url: `${this.uri}/local/list`,
      method: 'get',
      params,
    });
  }

  // 更新素材
  updateMaterialApi(data) {
    return request({
      url: `${this.uri}/local/updateMaterial`,
      method: 'post',
      data,
      headers: {
        'Content-Type':	'multipart/form-data; charset=UTF-8',
      },
    });
  }

  // 裁剪本地素材接口
  clipVideoApi(data) {
    return request({
      url: `${this.uri}/local/clipVideo`,
      method: 'post',
      data,
    });
  }

  // 调整视频倍数接口
  speedVideoApi(data) {
    return request({
      url: `${this.uri}/local/speedVideo`,
      method: 'post',
      data,
    });
  }

  // 获取素材的素材标签接口
  getLocalMaterialLabelsApi(material_id) {
    return request({
      url: `${this.uri}/local/${material_id}/labels`,
      method: 'get',
    });
  }

  // 素材添加更新素材标签接口
  addLocalMaterialLabelsApi(material_id, data) {
    return request({
      url: `${this.uri}/local/${material_id}/addLabels`,
      method: 'post',
      data,
    });
  }
}

export { MaterialResource as default };
